
export const CampaignListFiltersConstants = {
	SET_CAMPAIGNS_LIST_FILTERS: 'SET_CAMPAIGNS_LIST_FILTERS',
	SET_CAMPAIGNS_LIST_SAVED_FILTERS: 'SET_CAMPAIGNS_LIST_SAVED_FILTERS',
	SET_CAMPAIGNS_LIST_PREVIOUS_FILTERS: 'SET_CAMPAIGNS_LIST_PREVIOUS_FILTERS'
}